import './Logo.css';

export function Logo() {
    return (
        <div className="d5-logo">
            Steam<span>Zip</span>
        </div>
    );
}
